// extracted by mini-css-extract-plugin
module.exports = {"catcher":"Catcher_catcher__5QQdd"};